module.exports = __webpack_public_path__ + "static/media/male_avatar.0c675689.svg";